export default function Container({ children }) {
  // only using fixed width on container in `lg` and above
  // can adjust if we want container centered and width restricted
  // for smaller breakpoints as well. Since Figma mocks are at
  // fixed screen sizes using my best judgement here for
  // desired behavior between breakpoints.
  return <div className='w-full px-10 lg:container'>{children}</div>;
}
